import React, { useEffect } from 'react';
import ProjectCard from '../components/ProjectCard';
import Navbar from '../components/Navbar';
import ProjectsHeader from '../components/ProjectsHeader';
// import contentDict from '../content/projects/example/project';
import allProjectDicts from '../content/allContent';
import { navbarHeight } from '../App';
import Footer from '../components/Footer';
import { FaArrowRight } from 'react-icons/fa';
import LaptopMockup from '../components/mockupComponents/LaptopMockup';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';


const ProjectsPage = ({ theme, setTheme }) => {
  
  const location = useLocation();

  ReactGA.send({ hitType: "pageview", page: "/projects", title: "ProjectsPageViews" });

  const projects = allProjectDicts.map((projectDict, idx) => {
    if (!projectDict.isResearch){
      return <ProjectCard key={idx} contentDict={projectDict}/>
    }
  })

  const researchProjects = allProjectDicts.map((projectDict, idx) => {
    if (projectDict.isResearch){
      return <ProjectCard key={idx} contentDict={projectDict}/>
    }
  })

  useEffect(() => {
    // Check if the URL contains a hash with an ID.
    // Executes when this page is opened using a link that contains an ID hash, e.g. /projects##musio.
    // Then scroll to the requested project.
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));

      if (element) {
        window.scrollTo({
          top: element.offsetTop - 60,
          behavior: 'smooth',
        });
      }
    }
  }, [location]);
  

  return (
    <div className='bg-light dark:bg-dark dark:text-light cursor-auto'>
      <Navbar theme={theme} setTheme={setTheme}/>
      <div className="p-4 min-h-screen" style={{paddingTop: navbarHeight}}>
        <div className="m-auto max-w-3xl">
          <ProjectsHeader title={"Research"} subtitle={"Research projects I worked on during my Master's at TUM."}/>
          {researchProjects}
          <ProjectsHeader title={"Projects"} subtitle={"Personal projects from hackathons, etc."}/>
          {projects}
          <div className='flex justify-center mt-14'>
            <a href="https://github.com/philippwulff" target='_blank' className='flex items-center shadow-3xl bg-light-accent border-2 border-dark dark:border-light dark:bg-dark-accent rounded-full p-2 px-5 text-xl text-dark dark:text-light hover:cursor-pointer hover:bg-opacity-70'>
              More Projects on GitHub <FaArrowRight className='ml-3'/>
            </a>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default ProjectsPage